module.exports = __webpack_public_path__ + "img/default-buffalo.dae31dc1.svg";